const V = {
  name: "Austin",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 14V16H13V14H15Z" fill="currentColor"/>
<path d="M11 14V16H9V14H11Z" fill="currentColor"/>
<path d="M13 2.17082C13.4226 2.32053 13.8041 2.56403 14.1172 2.88285C14.6731 3.42881 15 4.18259 15 5V5.67502C17.076 6.66279 18.5909 8.643 18.9289 11H20V13H19V17H23V24H21V19H19V24H17V19H15V24H13V19H11V24H9V19H7V24H5V19H3V24H1V17H5V13H4V11H5.07108C5.40909 8.643 6.92395 6.66279 9 5.67502V5C9 3.69806 9.83678 2.58522 11 2.17183V0H13V2.17082ZM11 5.07108C11.3266 5.02424 11.6605 5 12 5C12.3395 5 12.6734 5.02424 13 5.07108V5C13 4.7222 12.8908 4.48003 12.7126 4.30673L12.7028 4.29717L12.6933 4.28735C12.52 4.10924 12.2778 4 12 4C11.4523 4 11 4.45228 11 5V5.07108ZM12 7C9.58466 7 7.56472 8.72007 7.10038 11H16.8996C16.4353 8.72007 14.4153 7 12 7ZM17 17V13H7V17H17Z" fill="currentColor"/>
</svg>
  `
};
export {
  V as Austin
};
